export default "__VITE_ASSET__BljLtKVf__"